import gym from './gym.svg';
import gym_white from './gym_white.svg';
import entrance from './entrance.svg';
import entrance_white from './entrance_white.svg';
import garage from './garage.svg';
import garage_white from './garage_white.svg';
import rooftop from './rooftop.svg';
import rooftop_white from './rooftop_white.svg';
import pool from './pool.svg';
import pool_white from './pool_white.svg';
import spa from './spa.svg';
import spa_white from './spa_white.svg';
import playground from './playground.svg';
import playground_white from './playground_white.svg';
import restroom from './restroom.svg';
import restroom_white from './restroom_white.svg';
import park from './park.svg';
import park_white from './park_white.svg';

export default {
  gym,
  gym_white,
  entrance,
  entrance_white,
  garage,
  garage_white,
  rooftop,
  rooftop_white,
  pool,
  pool_white,
  spa,
  spa_white,
  playground,
  playground_white,
  restroom,
  restroom_white,
  park,
  park_white,
};
